/**
 * Thin wrapper around `marked` with safe defaults for our use:
 * - GitHub-flavored breaks (single newline = <br>)
 * - No raw HTML in input (we render trusted mock data; if we ever take
 *   user input, sanitize at the boundary, not here)
 */

import { marked, type MarkedOptions } from "marked";

const OPTS: MarkedOptions = {
  gfm: true,
  breaks: true,
};

export function renderMarkdown(src: string): string {
  return marked.parse(src, OPTS) as string;
}
